import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import NavigationSidebar from '../../components/ui/NavigationSidebar';
import ProductFilters from './components/ProductFilters';
import BulkActionsBar from './components/BulkActionsBar';
import ProductTable from './components/ProductTable';
import ProductModal from './components/ProductModal';
import ProductValidationModal from './components/ProductValidationModal';
import ProductPagination from './components/ProductPagination';
import Button from '../../components/ui/Button';
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import { logout } from '../../utils/auth';



const ProductManagement = () => {
  const [userId, setUserId] = useState(null);
  const [API_URL, setAPI_URL] = useState("");

  useEffect(() => {
    const id = localStorage.getItem('_id');
    setUserId(id);
    const apiUrl =
      id === "56"
        ? `${import.meta.env.VITE_CATDEMO_BASE_URL}/product_details/all/page`
        : `${import.meta.env.VITE_CATPROD_BASE_URL}/product_details/all/page`;
    setAPI_URL(apiUrl);
    // console.log("LId:", id);
    // console.log("API_URL:", apiUrl);
  }, []);

  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [products, setProducts] = useState([]);
  const handleLogout = () => {
    logout();
    window.location.href = '/admin-login';
  };
  const [errorMessage, setErrorMessage] = useState('');
  const [isCodeSearchActive, setIsCodeSearchActive] = useState(false);
  const [isCategorySearchActive, setIsCategorySearchActive] = useState(false);
  const [isBrandSearchActive, setIsBrandSearchActive] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [totalItems, setTotalItems] = useState(0);
  const [isProductModalOpen, setIsProductModalOpen] = useState(false);
  const [isValidationModalOpen, setIsValidationModalOpen] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [modalMode, setModalMode] = useState('create');
  const [loading, setLoading] = useState(false);
  const [debugHeader, setDebugHeader] = useState('');
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [isBulkMode, setIsBulkMode] = useState(false);
  const [isGridView, setIsGridView] = useState(false);

  // ----------------- Fetch all products (default) -----------------
  // const fetchProducts = async () => {
  //   setLoading(true);
  //   try {
  //     const url = `${API_URL}?page=${Math.max(currentPage - 1, 0)}&size=${itemsPerPage}${searchTerm ? `&search=${encodeURIComponent(searchTerm)}` : ''}`;
  //     const token = localStorage.getItem('authToken');
  //     const response = await fetch(url, {
  //       headers: {
  //         'accept': '*/*',
  //         'Authorization': `Bearer ${token}`
  //       }
  //     });
  //     const allHeaders = {};
  //     response.headers.forEach((value, key) => {
  //       allHeaders[key] = value;
  //     });
  //     setDebugHeader(JSON.stringify(allHeaders, null, 2));
  //     const data = await response.json();
  //     setProducts(Array.isArray(data) ? data : []);
  //     setTotalItems(1126); // Hardcoded for now
  //   } catch (error) {
  //     setProducts([]);
  //     setTotalItems(0);
  //     setDebugHeader(error?.message || 'Error');
  //   }
  //   setLoading(false);
  // };

  // ----------------- Fetch all products (default) -----------------
  const fetchProducts = async () => {
    setLoading(true);

    try {
      const url = `${API_URL}?page=${Math.max(currentPage - 1, 0)}&size=${itemsPerPage}${
        searchTerm ? `&search=${encodeURIComponent(searchTerm)}` : ''
      }`;

      const token = localStorage.getItem('authToken');

      const response = await fetch(url, {
        headers: {
          accept: '*/*',
          Authorization: `Bearer ${token}`,
        },
      });
      //console.log(response.headers.get('x-total-count'));
      const totalCountHeader = response.headers.get('x-total-count');

      // Optional debug
      const allHeaders = {};
      response.headers.forEach((value, key) => {
        allHeaders[key] = value;
      });
      setDebugHeader(JSON.stringify(allHeaders, null, 2));

      const data = await response.json();

      setProducts(Array.isArray(data) ? data : []);

      setTotalItems(totalCountHeader ? Number(totalCountHeader) : 0);

    } catch (error) {
      setProducts([]);
      setTotalItems(0);
      setDebugHeader(error?.message || 'Error');
    }

    setLoading(false);
  };

  useEffect(() => {
    if (
      API_URL &&
      !isCodeSearchActive &&
      !isCategorySearchActive &&
      !isBrandSearchActive &&
      !errorMessage
    ) {
      fetchProducts();
    }
  }, [API_URL, currentPage, itemsPerPage, isCodeSearchActive, isCategorySearchActive, isBrandSearchActive, errorMessage]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  // ----------------- Product code search -----------------
  const handleProductCodeSearch = (result) => {
    if (result?.status === 'success' && result?.data) {
      setProducts([result.data]);
      setTotalItems(1);
      setIsCodeSearchActive(true);
      setIsCategorySearchActive(false);
      setIsBrandSearchActive(false);
    } else if (result?.status === 'clear') {
      setIsCodeSearchActive(false);
    } else {
      setProducts([]);
      setTotalItems(0);
      setIsCodeSearchActive(true);
      setIsCategorySearchActive(false);
      setIsBrandSearchActive(false);
    }
  };

  // ----------------- Category search -----------------
  const handleCategorySearch = (result) => {
    if (result?.status === 'clear') {
      setIsCategorySearchActive(false);
      setErrorMessage('');
      return;
    }
    if (Array.isArray(result) && result.length > 0) {
      setProducts(result);
      setTotalItems(result.length);
      setIsCategorySearchActive(true);
      setIsCodeSearchActive(false);
      setIsBrandSearchActive(false);
      setErrorMessage('');
    } else if (result?.status === 'error') {
      setProducts([]);
      setTotalItems(0);
      setIsCategorySearchActive(true);
      setIsCodeSearchActive(false);
      setIsBrandSearchActive(false);
      setErrorMessage(result.message || 'Failed to fetch category products.');
    } else {
      setProducts([]);
      setTotalItems(0);
      setIsCategorySearchActive(true);
      setIsCodeSearchActive(false);
      setIsBrandSearchActive(false);
      setErrorMessage('No products found for this category.');
    }
  };

  // ----------------- Brand search -----------------
  const handleBrandSearch = (result) => {
    if (result?.status === 'clear') {
      setIsBrandSearchActive(false);
      setErrorMessage('');
      return;
    }
    if (Array.isArray(result) && result.length > 0) {
      setProducts(result);
      setTotalItems(result.length);
      setIsBrandSearchActive(true);
      setIsCodeSearchActive(false);
      setIsCategorySearchActive(false);
      setErrorMessage('');
    } else if (result?.status === 'error') {
      setProducts([]);
      setTotalItems(0);
      setIsBrandSearchActive(true);
      setIsCodeSearchActive(false);
      setIsCategorySearchActive(false);
      setErrorMessage(result.message || 'Failed to fetch brand products.');
    } else {
      setProducts([]);
      setTotalItems(0);
      setIsBrandSearchActive(true);
      setIsCodeSearchActive(false);
      setIsCategorySearchActive(false);
      setErrorMessage('No products found for this brand.');
    }
  };

  const handleCreateProduct = () => {
    setSelectedProduct(null);
    setModalMode('create');
    setIsBulkMode(false);
    setIsProductModalOpen(true);
  };

  const handleEditProduct = (product) => {
    setSelectedProduct(product);
    setModalMode('edit');
    setIsBulkMode(false);
    setIsProductModalOpen(true);
  };

  const handleBulkMapping = () => {
    if (selectedProducts.length === 0) return;
    setSelectedProduct(null);
    setModalMode('edit');
    setIsBulkMode(true);
    setIsProductModalOpen(true);
  };

  const handleShowSuccess = (message) => {
    setSuccessMessage(message);
    setShowSuccessPopup(true);
    setTimeout(() => {
      setShowSuccessPopup(false);
      setSuccessMessage('');
    }, 2000);
  };

  const handleSave = () => {
    fetchProducts(); // refresh table
  };

  const handleDeleteProduct = (product) => {
    if (window.confirm(`Are you sure you want to delete "${product?.product_name}"?`)) {
      setProducts(prev => prev?.filter(w => w?.product_id !== product?.product_id));
      setSelectedProducts(prev => prev?.filter(id => id !== product?.product_id));
    }
  };

  const handleSelectProduct = (productId, checked) => {
    setSelectedProducts(prev => 
      checked 
        ? [...prev, productId]
        : prev?.filter(id => id !== productId)
    );
  };

  const handleSelectAll = (checked) => {
    setSelectedProducts(checked ? products?.map(w => w?.product_id) : []);
  };

  const handleBulkDelete = () => {
    if (window.confirm(`Are you sure you want to delete ${selectedProducts?.length} product(s)?`)) {
      setProducts(prev => prev?.filter(w => !selectedProducts?.includes(w?.product_id)));
      setSelectedProducts([]);
    }
  };

  // ----------------- BULK EXPORT -----------------
  const handleBulkExport = () => {
    const selectedProductData = products?.filter(w => selectedProducts?.includes(w?.product_id));
    if (!selectedProductData || selectedProductData.length === 0) {
      alert("No products selected for export.");
      return;
    }

    const exportData = selectedProductData.map((item, idx) => ({
      '#': idx + 1,
      ProductID: item.product_id ?? item.productId,
      SKU: item.sku_code ?? item.skuCode,
      Name: item.product_name ?? item.productName,
      Brand: item.brand_name ?? item.brandName,
      'Primary Category': item.primaryCategoryName ?? item.primary_category_name ?? item.category_name,
      'Sub Category': item.subCategoryName ?? item.sub_category_name ?? item.category_name,
      MRP: item.product_mrp ?? item.productMrp,
      'Image 1': item.images?.image1 ?? '',
      'Image 2': item.images?.image2 ?? '',
      'Image 3': item.images?.image3 ?? '',
      'Product Price': item.product_price ?? item.productPrice,
      'Transfer Price': item.transfer_price ?? item.transferPrice,
      'Shipping Amt': item.shipping_amount ?? item.shippingAmount
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "SelectedProducts");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "selected_products.xlsx");
  };

  // ----------------- EXPORT ALL -----------------
  const handleExportExcel = async () => {
    try {
      const token = localStorage.getItem('authToken');
      // Use userId from state
      const baseUrl =
        userId === "56"
          ? import.meta.env.VITE_CATDEMO_BASE_URL
          : import.meta.env.VITE_CATPROD_BASE_URL;
      const fetchUrl = `${baseUrl}/product_details/all`;
      console.log("[Export] fetchUrl:", fetchUrl);
      const response = await fetch(fetchUrl, {
        method: 'GET',
        headers: {
          'accept': '*/*',
          'Authorization': `Bearer ${token}`
        }
      });

    if (!response.ok) {
      throw new Error(`Failed to fetch products: ${response.status}`);
    }

    const data = await response.json();

    if (!Array.isArray(data) || data.length === 0) {
      alert("No products available to export.");
      return;
    }

    const exportData = data.map((item, idx) => ({
      '#': idx + 1,
      ProductID: item.product_id ?? item.productId,
      SKU: item.sku_code ?? item.skuCode,
      Name: item.product_name ?? item.productName,
      Brand: item.brand_name ?? item.brandName,
      'Primary Category': item.primaryCategoryName ?? item.primary_category_name ?? item.category_name,
      'Sub Category': item.subCategoryName ?? item.sub_category_name ?? item.category_name,
      MRP: item.product_mrp ?? item.productMrp,
      'Image 1': item.images?.image1 ?? '',
      'Image 2': item.images?.image2 ?? '',
      'Image 3': item.images?.image3 ?? '',
      'Product Price': item.product_price ?? item.productPrice,
      'Transfer Price': item.transfer_price ?? item.transferPrice,
      'Shipping Amt': item.shipping_amount ?? item.shippingAmount
    }));

    const ws = XLSX.utils.json_to_sheet(exportData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Products");

    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(blob, "products.xlsx");

  } catch (error) {
    console.error("Export failed:", error);
    alert("Export failed. Please try again.");
  }
};


  const handleClearFilters = () => {
    setSearchTerm('');
    setIsCodeSearchActive(false);
    setIsCategorySearchActive(false);
    setIsBrandSearchActive(false);
    setErrorMessage('');
    fetchProducts(); // reload all
  };

  const totalPages = Math.ceil(totalItems / itemsPerPage);

  return (
    <>
      <Helmet>
        <title>Product Management - Lakeee Shop API Documentation</title>
        <meta name="description" content="Configure and monitor product endpoints for real-time API event notifications in Lakeee Shop" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <NavigationSidebar
          isCollapsed={isSidebarCollapsed}
          onToggle={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
          userRole="admin"
          isAuthenticated={true}
            onLogout={handleLogout}
          />

        <main className={`
          transition-all duration-300 ease-in-out
          ${isSidebarCollapsed ? 'lg:ml-16' : 'lg:ml-80'}
        `}>
          {/* Mobile Header */}
          <div className="lg:hidden flex items-center justify-between p-4 border-b border-border bg-card">
            <Button
              variant="ghost"
              size="sm"
              iconName="Menu"
              onClick={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
            />
            <h1 className="text-lg font-semibold text-foreground">Product Management </h1>
            <div className="w-10" />
          </div>

          <div className="p-6 space-y-6">
            {/* Error message */}
            {errorMessage && (
              <div className="mb-4 p-3 bg-red-100 text-red-700 rounded">
                {errorMessage}
              </div>
            )}

            <ProductFilters
              onProductCodeSearch={handleProductCodeSearch}
              onCategorySearch={handleCategorySearch}
              onBrandSearch={handleBrandSearch}
              onClearFilters={handleClearFilters}
              onExportExcel={handleExportExcel}
              onCreateProduct={handleCreateProduct}
              isGridView={isGridView}
              onToggleView={setIsGridView}
            />

            <BulkActionsBar
              selectedCount={selectedProducts?.length}
              onClearSelection={() => setSelectedProducts([])}
              onBulkDelete={handleBulkDelete}
              onBulkExport={handleBulkExport}
              onBulkEnable={handleBulkMapping}
            />

            <ProductTable
              products={products}
              loading={loading}
              onEdit={handleEditProduct}
              onDelete={handleDeleteProduct}
              selectedProducts={selectedProducts}
              onSelectProduct={handleSelectProduct}
              onSelectAll={handleSelectAll}
              isGridView={isGridView}
            />

            <ProductPagination
              currentPage={currentPage}
              totalPages={totalPages}
              totalItems={totalItems}
              itemsPerPage={itemsPerPage}
              onPageChange={setCurrentPage}
              onItemsPerPageChange={setItemsPerPage}
            />
          </div>
        </main>

        {/* Modals */}
        <ProductModal
          isOpen={isProductModalOpen}
          onClose={() => setIsProductModalOpen(false)}
          product={selectedProduct}
          onSave={handleSave}
          mode={modalMode}
          onShowSuccess={handleShowSuccess}
          isBulkMode={isBulkMode}
          selectedProducts={selectedProducts}
          refreshProducts={fetchProducts}
        />

        <ProductValidationModal
          isOpen={isValidationModalOpen}
          onClose={() => setIsValidationModalOpen(false)}
          product={selectedProduct}
          onValidate={() => {}}
        />

        {showSuccessPopup && (
          <div className="fixed top-6 right-6 bg-green-600 text-white px-4 py-2 rounded shadow-lg z-200">
            {successMessage}
          </div>
        )}
      </div>
    </>
  );
};

export default ProductManagement;
